/**
 * The sections of the app that one build setting can switch on (#610, #625), and the rule for
 * reading it. ONE list and ONE rule, read by the web app (`apps/web/src/lib/sections.ts`) and by
 * the server (`apps/api/src/auth/sections.ts`), so the two cannot come to mean different things by
 * the same name.
 *
 *   not given             → every section is on, as before the setting existed
 *   given, names sections → those sections, and the Roster
 *   given, but empty or
 *   naming nothing known  → the Roster only
 *
 * So a typing mistake can only switch sections off.
 */
/** The sections in the HR app's side menu. */
export const HR_SECTION_KEYS = ['dashboard', 'hiring', 'roster', 'review', 'forms'];
/** Those, and the candidate portal: not in any menu, but switched on and off by the same setting. */
export const SECTION_KEYS_WITH_PORTAL = [...HR_SECTION_KEYS, 'portal'];
/** The section that can never be switched off. */
export const ALWAYS_ON_SECTION = 'roster';
/**
 * Read the setting against the names the caller knows. A name outside `known` is ignored, which is
 * how the web app's menu can read a list that also says `portal`.
 */
export function parseSectionSetting(setting, known, alwaysOn) {
    if (setting === undefined)
        return new Set(known);
    const names = setting.toLowerCase().split(/[\s,]+/).filter((name) => name !== '');
    if (names.includes('all'))
        return new Set(known);
    return new Set([alwaysOn, ...known.filter((key) => names.includes(key))]);
}
//# sourceMappingURL=sections.js.map